<template>
  <div>
    <a-row style="color: black">
      <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }"
        >Gene:
        <br />
        <a-input
          style="width: 60%"
          :placeholder="this.gene"
          :disabled="disabled"
        ></a-input>
        <br />
        <br />
        Top # similar Genes
        <br />
        <a-input style="width: 60%" v-model="value"></a-input>
      </a-col>
      <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
        Cancer:
        <a-select
          v-model="cancerdemo"
          style="width: 100%"
          placeholder="select one or more perturbed gene"
          option-label-prop="label"
        >
          <a-select-option v-for="ca in this.cancerlist" :key="ca" :label="ca">
            {{ ca }}
          </a-select-option>
        </a-select>
        <br />
        <br />
        <span style="color: grey"
          >The plot is based on the all samples of tumor.</span
        >

        <a-button type="primary" style="width: 100%" @click="listSimiGene()"
          >List</a-button
        >
      </a-col>
    </a-row>
    <a-skeleton :loading="this.zhanwei" active> </a-skeleton>
    <a-card
      style="width: 100%; margin-top: 10px; height: 570px"
      v-show="visible"
    >
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        row-id="id"
        size="small"
        :row-config="{ height: 35, isCurrent: true, isHover: true }"
        ref="xTable"
        :data="tableData_detable"
        :loading="loading"
        align="center"
        header-align="center"
      >
        <vxe-column field="ne" title="Gene name" type="html"></vxe-column>
        <vxe-column field="eg" title="Gene ID" type="html"></vxe-column>
        <vxe-column field="r" title="PCC" type="html"></vxe-column>
        <vxe-column field="p" title="P-value" type="html"></vxe-column>
        <vxe-column field="plot" title="View" type="html">
          <template #default="{ row }">
            <a-tag
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="showPDF(row.ne, row.eg)"
              >Explore</a-tag
            >
          </template>
        </vxe-column>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[10, 20, 50]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-card>
    <a-modal
      :visible="this.simiplotModal"
      :maskClosable="true"
      :destroyOnClose="true"
      :keyboard="true"
      :closable="false"
      style="margin-top: 500px"
      :width="800"
      @ok="handleOk3"
      @cancel="handleCancel3"
      :cancel-button-props="{ props: { disabled: true } }"
    >
      <div slot="title">Similar genes plot in TCGA-{{ this.cancerdemo }}</div>
      <div slot="cancelText">
        <a-icon type="cloud-download" />
      </div>
      <a-spin size="large" :spinning="simiplot_visible" :indicator="indicator">
        <object :data="this.simiplotlinks" width="100%" height="480"></object>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
export default {
  props: ["ensgId", "gene", "selectCa"],
  name: "survival",
  watch: {
    cancerdemo() {
      this.zhanwei = true;
      this.visible = false;
    },
    // cancerdemo() {
    //   axios
    //     .get(
    //       "http://research.gzsys.org.cn/perturbdb/data/TCGA/02perturbDB_cor/result/" +
    //         this.ensgId +
    //         "." +
    //         this.cancerdemo +
    //         ".json"
    //     )
    //     .then((response) => {
    //       console.log(response.data);
    //       this.getdata_detable = response.data
    //         .filter((item) => item.ne !== this.gene)
    //         .sort((a, b) => b.r - a.r)
    //         .slice(0, this.value);
    //       this.findList_detable(this.getdata_detable);
    //       this.loading = false;
    //     });
    // },
  },
  created() {},
  methods: {
    showPDF(v1, v2) {
      this.simiplot_visible = true;
      this.simiplotlinks = "";
      this.simiplotModal = true;
      // 绘制图片
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/02simiplot.php",
          {
            params: {
              n1: v1,
              g1: v2,
              n2: this.gene,
              g2: this.ensgId,
              ca: this.cancerdemo,
            },
          }
        )
        .then((response) => {
          this.simiplot_visible = false;
          if (response.data != "failed") {
            this.simiplot_visible = false;
            this.$message.success(response.data + ".pdf plotted!", 6);
            this.simiplotlinks =
              "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
              response.data +
              ".pdf#zoom=70";
          } else {
            this.$message.error("step error, please contact us for a help!", 6);
          }
        });
    },
    handleOk3() {
      this.simiplotModal = false;
    },
    listSimiGene() {
      this.findList_detable(null);
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/data/TCGA/02perturbDB_cor/result/" +
            this.ensgId +
            "." +
            this.cancerdemo +
            ".json"
        )
        .then((response) => {
          console.log(response.data);
          this.getdata_detable = response.data
            .filter((item) => item.ne !== this.gene)
            .sort((a, b) => b.r - a.r)
            .slice(0, this.value);
          this.findList_detable(this.getdata_detable);
          this.visible = true;
          this.loading = false;
          this.zhanwei = false;
        });
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename:
            "Top" +
            this.value +
            "_similar-genes_of_" +
            this.gene +
            "_in_TCGA-" +
            this.cancerdemo,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            "Top" +
            this.value +
            "_similar-genes_of_" +
            this.gene +
            "_in_TCGA-" +
            this.cancerdemo +
            "_searching-by_" +
            this.filterName_detable,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["ne", "eg"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        // 必须装回来
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
  },
  data() {
    return {
      disabled: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      simiplot_visible: true,
      simiplotlinks: "",
      // gene: this.$route.query.gene,
      //配置
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      lowPercent: 50,
      highPercent: 50,
      cancerdemo: this.selectCa,
      cancerlist: [
        "ACC",
        "BLCA",
        "BRCA",
        "CESC",
        "CHOL",
        "COAD",
        "DLBC",
        "ESCA",
        "GBM",
        "HNSC",
        "KICH",
        "KIRC",
        "KIRP",
        "LAML",
        "LGG",
        "LIHC",
        "LUAD",
        "LUSC",
        "MESO",
        "OV",
        "PAAD",
        "PCPG",
        "PRAD",
        "READ",
        "SARC",
        "SKCM",
        "STAD",
        "TGCT",
        "THCA",
        "THYM",
        "UCEC",
        "UCS",
        "UVM",
      ],
      // 表格参数
      visible: false,
      // 基因个数
      value: 20,
      // plot
      simiplotModal: false,
      //加载
      loading: false,
      zhanwei: false,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: true,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
};
</script>
